import { useGetApiNotifications } from '@/api';
import { useListingContrats } from '@/hooks/useListingContrats';

const useNotificationsFilters = () => {
  const { data: listContratData, isLoading: isLoadingContrats } = useListingContrats();
  const { data: listNotifications, isLoading: isLoadingNotifications, isError } = useGetApiNotifications();

  const hasSpirica = listContratData?.listContrat?.some((contrat) => contrat.gestionnaire === 'Spirica') ?? false;
  const notifications = listNotifications?.notifications ?? [];

  const filteredNotifications = hasSpirica
    ? notifications
    : notifications.filter((notif) => notif.id === 'pk-processing-delay-2026-04');

  return { filteredNotifications, isLoading: isLoadingContrats || isLoadingNotifications, isError };
};

export { useNotificationsFilters };
